<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', perfil)">
      <v-card v-if="item" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Perfil </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.nome"
                    :rules="[obrigatorio]"
                    label="Nome"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(item)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Perfil from '../../models/perfil'
import PerfilService from '../../services/usuario/perfil'
import { obrigatorio } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'perfil', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    item: new Perfil(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    perfil() {
      return this.perfil ? (this.item = this.perfil) : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const perfilSalvo =
          this.operacao === 'adicionar'
            ? await PerfilService.create(item)
            : await PerfilService.update(item.id, item)

        this.$emit('confirmado', perfilSalvo)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$refs.formDialog.reset()
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
